import { useEffect } from "react";
import { useAppModal } from "./AppModalProvider";
import { getPresenceConsent, sendPresenceHeartbeat, setPresenceConsent } from "../services/presenceConsent";
import { runAutoDialog } from "../services/autoDialogCoordinator";

export function PresenceConsentGate() {
  const modal = useAppModal();
  useEffect(() => {
    let timer = 0; let cancelled = false;
    const start = () => { void sendPresenceHeartbeat(); timer = window.setInterval(() => { void sendPresenceHeartbeat(); }, 10 * 60 * 1000); };
    if (getPresenceConsent() === "unknown") void runAutoDialog("presence-consent", () => modal.confirm({ title: "匿名在线统计", message: "是否允许发送最小在线心跳？只包含随机安装标识和时间，不包含 Discord 身份、存档、对话、模型配置或 API 密钥。你可随时在设置中关闭。", confirmLabel: "允许", cancelLabel: "不允许" })).then((accepted) => { if (cancelled) return; setPresenceConsent(accepted ? "granted" : "denied"); if (accepted) start(); });
    else if (getPresenceConsent() === "granted") start();
    const onVisibility = () => { if (document.visibilityState === "visible") void sendPresenceHeartbeat(); };
    document.addEventListener("visibilitychange", onVisibility);
    return () => { cancelled = true; window.clearInterval(timer); document.removeEventListener("visibilitychange", onVisibility); };
  }, [modal.confirm]);
  return null;
}
